






































































import { Component, Vue, Prop } from 'vue-property-decorator'
import firebase from '@/plugins/firebase'
import { Device } from '@/models/device'
import DisplayPhoneNumber from '@/components/common/DisplayPhoneNumber.vue'
import DisplayTime from '@/components/common/DisplayTime.vue'

@Component({ components: { DisplayPhoneNumber, DisplayTime } })
export default class DeviceInfo extends Vue {
  @Prop({ type: Object, required: true }) doc!: firebase.firestore.DocumentSnapshot<Device>

  get item (): Device | null {
    return this.doc.data() || null
  }

  get driverName (): string {
    return this.item?.info.driverName || '이름없음'
  }
}
